module.exports = __webpack_public_path__ + "ionicons.05acfdb568b3df49ad31.woff";


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/assets/fonts/ionicons.woff?v=2.0.0
// module id = ../../../../../src/assets/fonts/ionicons.woff?v=2.0.0
// module chunks = styles